import styled from 'styled-components/macro';

type HeaderOffsetStyledT = {
  headerOffsetPx: number;
};

export const LayoutStyled = styled.div<HeaderOffsetStyledT>`
  display: flex;
  height: 100vh;
  min-height: 0;
  overflow: hidden;
  padding-top: ${({ headerOffsetPx }: HeaderOffsetStyledT): string => `${headerOffsetPx}px`};
`;

export const ContentWrapStyled = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }): string => theme.colors.surface};
  overflow: hidden;
  padding: 0 0 1rem;
`;
